// CHAT
export const CONNECTED = "CONNECTED";
export const DISCONNECTED = "DISCONNECTED";
export const MINIMIZE = "MINIMIZE";
export const AFTER_ACTIONS = "AFTER_ACTIONS";
export const RATING = "RATING";
export const CLOSE_CHAT_CONFIRMATION = "CLOSE_CHAT_CONFIRMATION";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js